import { computed, defineComponent, reactive } from 'vue';
import moment from 'moment';
import { useModelWrapper, DateHelper } from '@hems/util';
import VCalendarWrapper from './VCalendarWrapper.vue';
export default defineComponent({
    name: 'VCalendar',
    components: {
        VCalendarWrapper,
    },
    inheritAttrs: false,
    props: {
        modelValue: {
            type: Object,
            required: true,
        },
        langCd: {
            type: String,
            default: 'en',
        },
        format: {
            type: String,
            default: null,
        },
        minDate: Date,
        maxDate: Date,
        validate: Function,
    },
    setup(props, { emit }) {
        const state = reactive({
            open: false,
            value: useModelWrapper(props, emit),
        });
        const displayValue = computed(() => props.format
            ? moment(state.value).format(props.format)
            : DateHelper.getDateFormatter(props.langCd, {
                year: 'numeric',
                month: 'numeric',
                day: 'numeric',
                hour12: false,
            })
                .format(state.value)
                .toString());
        return {
            state,
            displayValue,
            onOpen: () => (state.open = true),
            onClose: () => (state.open = false),
        };
    },
});
